import { h } from "@stencil/core";
export const renderStyles = ({ baseClass, sliderId, containerWidthXl, containerWidthL, containerWidthM, containerWidthS, breakpointL, breakpointM, breakpointS, arrowsFollowImg, arrowsOffsetTop, hasOverflowingSlides, handleDuplicatesFlag, noArrows }) => {
    const hasCustomWidth = containerWidthXl === "100%" && containerWidthL === "100%" && containerWidthM === "100%" && containerWidthS === "100%"
        ? false
        : true;
    return (h("div", null, !noArrows && (h("style", null, `
                    @media only screen and (max-width: 567px) {
                        .${baseClass}[slider-id="${sliderId}"] .ux-slider-button-prev,
                        .${baseClass}[slider-id="${sliderId}"] .ux-slider-button-next {
                            display: none;
                        }
                    }
                `)), !handleDuplicatesFlag && (h("style", null, `
                        .${baseClass}[slider-id="${sliderId}"] .ux-slider-slide-duplicate {
                            visibility: hidden;
                        }
                    `)), !hasOverflowingSlides && (h("style", null, `
                        .${baseClass}[slider-id="${sliderId}"] .${baseClass}-button-next,
                        .${baseClass}[slider-id="${sliderId}"] .${baseClass}-button-prev,
                        .${baseClass}[slider-id="${sliderId}"] .${baseClass}-pagination {
                            display: none;
                        }
                    `)), hasCustomWidth && (h("style", null, `
                        .${baseClass}[slider-id="${sliderId}"] .${baseClass}-container {
                            width: ${containerWidthXl};
                        }
                        @media screen and (max-width: ${breakpointL}px) {
                            .${baseClass}[slider-id="${sliderId}"] .${baseClass}-container {
                                width: ${containerWidthL};
                            }
                        }
                        @media screen and (max-width: ${breakpointM}px) {
                            .${baseClass}[slider-id="${sliderId}"] .${baseClass}-container {
                                width: ${containerWidthM};
                            }
                        }
                        @media screen and (max-width: ${breakpointS}px) {
                            .${baseClass}[slider-id="${sliderId}"] .${baseClass}-container {
                                width: ${containerWidthS};
                            }
                        }
                    `)), arrowsFollowImg !== false && (h("style", null, `
                .${baseClass}[slider-id="${sliderId}"] .${baseClass}-button-next,
                .${baseClass}[slider-id="${sliderId}"] .${baseClass}-button-prev
                {
                    top: ${arrowsOffsetTop}px;
                }
                `))));
};
//# sourceMappingURL=slider-style-tags.js.map
